import React, { useState, useEffect } from 'react'
import {
  Card,
  Grid,
  CardContent,
  TextField,
  FormHelperText,
  Button,
  Dialog,
  DialogContent
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import MapboxMap from '../../../components/maps'
import classes from '../../../pages/createOrder/index.module.scss'
import CommonRepository from 'client-sdk/src/Repository/common-repository'
import ContactsRepository from 'client-sdk/src/Repository/contacts-repository'
import handleError from '../../../utils/handleError'
import { Controller } from 'react-hook-form'
import handleNotfication from '../../../utils/handleNotfication'
import RonadIcons from '../../iconComponent'

const provinces = {
  VIP: [1, 31],
  VVIP: [1],
  courier_COD: [1, 31]
}

const validateNumber = (value: any) => {
  if (!value) {
    return true
  }
  const pattern = /^[0-9]+$/
  return pattern.test(value)
}

function CustomerInfo(props: any) {
  const {
    disableAll,
    handleLocations,
    addressDisabled,
    locatedInTehran,
    location,
    editMode
  } = props
  const { errors, setValue, getValues, register, control } = props.form
  const values = getValues()
  const [provincesList, setProvincesList] = useState([])
  const [citiesList, setCitiesList] = useState([])
  const [openMsg, setOpenMsg] = useState(false)
  const [latLngState, setLatLngState] = useState<any>({
    lat: 0,
    lng: 0
  })

  const handleConfirmLocation = () => {
    handleLocations(latLngState)
    setOpenMsg(false)
  }

  useEffect(() => {
    getProvinces()
  }, [])

  const getCities = async (provinceId: number) => {
    try {
      const response = await CommonRepository.getCities({
        payload: { 'provinceId.equals': provinceId }
      })
      setCitiesList(response.data.filter((el: any) => el.isActive))
    } catch (err) {
      handleError(err)
    }
  }

  const getProvinces = async () => {
    try {
      const response = await CommonRepository.getProvinces({ payload: {} })
      setProvincesList(response.data)
    } catch (err) {
      handleError(err)
    }
  }

  const createContact = async (data: any) => {
    const {
      customerName,
      customerMobileNumber,
      customerZipCode,
      customerAddress,
      customerCity,
      customerProvince,
      customerNationalCode
    } = getValues()
    const { lat, lng } = location
    try {
      await ContactsRepository.createContact({
        payload: {
          data: {
            fullName: customerName,
            mobile:
              customerMobileNumber.length > 0 ? customerMobileNumber : null,
            address: customerAddress,
            nationalCode: customerNationalCode,
            city: customerCity,
            province: customerProvince,
            postalCode: customerZipCode,
            lat,
            lon: lng
          }
        }
      })
      handleNotfication('مخاطب جدید با موفقیت ایجاد شد', 'success')
    } catch (error) {
      handleError(error)
    }
  }

  const provinceList = () => {
    if (values.deliveryType == 'VVIP') {
      return provincesList.filter((el: any) => {
        return provinces['VVIP'].includes(el.id)
      })
    }
    if (
      values.deliveryType == 'COURIER' &&
      ['CHAPAR', 'nedex'].includes(values.orderTplType)
    ) {
      return provincesList.filter((el: any) => {
        return el.id !== 1
      })
    }
    return provincesList.filter((el: any) => el.isActive)
  }

  const handlerRomoveLocation = () => {
    handleLocations({ lat: 0, lng: 0 })
  }

  return (
    <Card className={classes.card}>
      <CardContent style={{ padding: '12px !important' }}>
        <Grid container spacing={3}>
          <Grid
            container
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            alignItems='flex-end'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='customerName'
                  label='نام و نام خانوادگی'
                  rules={{
                    required: true
                  }}
                  as={
                    <TextField
                      name='customerName'
                      type='search'
                      variant='outlined'
                      fullWidth
                      id='customerName'
                      disabled={values.deliveryType == '' || disableAll}
                      error={!!errors.customerName && !!errors.customerName}
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors.customerName && 'نام گیرنده الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            alignItems='flex-start'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='customerNationalCode'
                  label='کد ملی (۱۰ رقمی)'
                  rules={{
                    required: false,
                    validate: validateNumber
                  }}
                  as={
                    <TextField
                      type='search'
                      variant='outlined'
                      fullWidth
                      id='customerNationalCode'
                      disabled={values.deliveryType == '' || disableAll}
                      inputRef={register({
                        required: false,
                        minLength: 10,
                        maxLength: 10,
                        pattern: /[0-9]/
                      })}
                      error={
                        !!errors.customerNationalCode &&
                        !!errors.customerNationalCode
                      }
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors.customerNationalCode?.type === 'required' &&
                    'کد ملی سفارش دهنده الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {(errors.customerNationalCode?.type === 'minLength' ||
                    errors.customerNationalCode?.type === 'maxLength') &&
                    'کد ملی 10 رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.customerNationalCode?.type === 'validate' &&
                    'لطفا عدد انگلیسی وارد کنید'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            alignItems='flex-start'
          >
            <div className={classes.item}>
              <div dir='rtl' style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='customerMobileNumber'
                  label=' شماره همراه (۰۹۱۲۳۴۵۶۷۸۹)'
                  rules={{
                    required: true
                  }}
                  as={
                    <TextField
                      type='search'
                      variant='outlined'
                      fullWidth
                      inputRef={register({
                        required: true,
                        minLength: 11,
                        maxLength: 11,
                        pattern: /[0-9]/
                      })}
                      id='customerMobileNumber'
                      disabled={values.deliveryType == '' || disableAll}
                      error={
                        !!errors.customerMobileNumber &&
                        !!errors.customerMobileNumber
                      }
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors.customerMobileNumber?.type === 'required' &&
                    'شماره‌همراه سفارش‌دهنده الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {(errors.customerMobileNumber?.type === 'minLength' ||
                    errors.customerMobileNumber?.type === 'maxLength') &&
                    'شماره‌همراه سفارش‌دهنده 11 رقم می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.customerMobileNumber?.type === 'validate' &&
                    'لطفا عدد انگلیسی وارد کنید'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            alignItems='flex-start'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  name='customerProvince'
                  control={control}
                  defaultValue=''
                  rules={{ required: true }}
                  render={({ value }) => (
                    <Autocomplete
                      noOptionsText='موردی یافت نشد'
                      getOptionSelected={(option, value) =>
                        option.name === value?.name
                      }
                      getOptionLabel={(option) => option.name}
                      options={provinceList()}
                      inputValue={value}
                      disabled={locatedInTehran || disableAll}
                      id='customerProvince'
                      onChange={(event: any, newValue: any) => {
                        setValue('customerCity', '')
                        getCities(newValue?.id)
                        setValue('customerProvince', newValue?.name)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label='استان'
                          variant='outlined'
                          onChange={(e) =>
                            setValue('customerProvince', e.target.value)
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            )
                          }}
                        />
                      )}
                    />
                  )}
                />
                <FormHelperText error focused>
                  {errors?.customerProvince && 'استان سفاش‌دهنده الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            alignItems='flex-start'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  name='customerCity'
                  control={control}
                  defaultValue=''
                  rules={{ required: true }}
                  render={({ value }) => (
                    <Autocomplete
                      noOptionsText='موردی یافت نشد'
                      getOptionSelected={(option, value) =>
                        option.name === value?.name
                      }
                      getOptionLabel={(option) => option.name}
                      options={citiesList}
                      inputValue={value}
                      disabled={locatedInTehran || disableAll}
                      id='customerCity'
                      onChange={(event: any, newValue: any) => {
                        setValue('customerCity', newValue?.name)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label='شهر'
                          variant='outlined'
                          // inputRef={register({ required: true })}
                          // InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setValue('customerCity', e.target.value)
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            )
                          }}
                        />
                      )}
                    />
                  )}
                />
                <FormHelperText error focused>
                  {errors?.customerCity && 'شهر سفاش‌دهنده الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            alignItems='flex-start'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='customerZipCode'
                  label='کد پستی (۱۰ رقمی)'
                  rules={{
                    required: [
                      'EXPRESS_POST',
                      'TAPIN_POST',
                      'TAPIN_KETAB'
                    ].includes(values.orderTplType),
                    validate: validateNumber
                  }}
                  as={
                    <TextField
                      type='search'
                      variant='outlined'
                      fullWidth
                      id='customerZipCode'
                      inputRef={register({
                        required: true,
                        minLength: 10,
                        maxLength: 10,
                        pattern: /[0-9]/
                      })}
                      disabled={values.deliveryType == '' || disableAll}
                      error={
                        !!errors.customerZipCode && !!errors.customerZipCode
                      }
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors?.customerZipCode?.type === 'required' &&
                    'کد پستی سفارش‌دهنده الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {(errors.customerZipCode?.type === 'minLength' ||
                    errors.customerZipCode?.type === 'maxLength') &&
                    'کد پستی 10 رقم می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.customerZipCode?.type === 'validate' &&
                    'لطفا عدد انگلیسی وارد کنید'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={8}
            md={8}
            lg={8}
            alignItems='flex-end'
          >
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='customerAddress'
                  label='آدرس گیرنده'
                  rules={{
                    required: true
                  }}
                  as={
                    <TextField
                      type='search'
                      variant='outlined'
                      label='آدرس گیرنده'
                      fullWidth
                      disabled={addressDisabled || disableAll}
                      id='customerAddress'
                      name='customerAddress'
                      error={
                        !!errors.customerAddress && !!errors.customerAddress
                      }
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors?.customerAddress && 'آدرس گیرنده الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} sm={4} md={4} lg={4}>
            <div className={classes.item}>
              {location?.lat === 0 ? (
                <Button
                  variant='outlined'
                  className={classes.addProductIcon}
                  size='large'
                  onClick={() => setOpenMsg(true)}
                  data-cy='addProduct'
                  style={{
                    width: '100%',
                    height: '56px',
                    marginBottom: '2px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span>{'اضافه کردن موقعیت مکانی'}</span>
                  <RonadIcons
                    name='plusCircleOutline'
                    className='text-primary'
                  />
                </Button>
              ) : (
                <Button
                  variant='outlined'
                  className={classes.addProductIcon}
                  size='large'
                  style={{
                    width: '100%',
                    height: '56px',
                    marginBottom: '2px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    background: '#D6EBD480'
                  }}
                  data-cy='addProduct'
                >
                  <span>{'موقعیت مکانی ثبت شد!'}</span>
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#32CD32'
                    }}
                  >
                    <RonadIcons
                      onClick={() => setOpenMsg(true)}
                      name='edit'
                      size={0.9}
                      className='text-primary'
                    />
                    <RonadIcons
                      onClick={handlerRomoveLocation}
                      name='trash'
                      size={0.9}
                      style={{ color: ' red', marginRight: '12px' }}
                      className='text-error'
                    />
                  </span>
                </Button>
              )}
            </div>
          </Grid>

          <Grid container item xs={8} lg={8} alignItems='flex-end'>
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <Controller
                  style={{ width: '100%' }}
                  control={control}
                  name='description'
                  label='توضیحات'
                  rules={{
                    required: false
                  }}
                  as={
                    <TextField
                      label='توضیحات'
                      type='search'
                      variant='outlined'
                      fullWidth
                      id='description'
                      name='description'
                      disabled={values.deliveryType == '' || disableAll}
                    />
                  }
                />
              </div>
            </div>
          </Grid>
          <Grid container item xs={4} lg={4} alignItems='flex-end'>
            <div className={classes.item}>
              <Controller
                control={control}
                name='senderName'
                label='نام فرستنده'
                rules={{
                  required: false
                }}
                as={
                  <TextField
                    label='نام فرستنده'
                    type='search'
                    variant='outlined'
                    fullWidth
                    id='senderName'
                    name='senderName'
                  />
                }
              />
            </div>
          </Grid>

          <Grid container item xs={12} justifyContent='flex-end'>
            <Grid item>
              <Button
                variant='contained'
                color='primary'
                onClick={createContact}
                disabled={!values.customerName || !values.customerMobileNumber}
              >
                <RonadIcons name='star' className='text-warning' />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Dialog
        className={classes.mapDialogStyle}
        open={openMsg}
        onClose={() => setOpenMsg(false)}
        aria-labelledby='responsive-dialog-title'
        maxWidth='md'
        fullWidth
      >
        <Grid container>
          <DialogContent>
            <Grid item md={12} lg={12}>
              <div>
                <MapboxMap
                  editMode={editMode}
                  positionMarker={location}
                  setLatlng={(latLng: { lat: number; lng: number }) => {
                    setLatLngState(latLng)
                  }}
                />
              </div>
              <div style={{ margin: '25px 0', textAlign: 'center' }}>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleConfirmLocation}
                >
                  {`تایید موقعیت مکانی`}
                </Button>
                <Button
                  style={{ marginRight: '8px' }}
                  variant='outlined'
                  color='primary'
                  onClick={() => setOpenMsg(false)}
                >
                  {`انصراف`}
                </Button>
              </div>
            </Grid>
          </DialogContent>
        </Grid>
      </Dialog>
    </Card>
  )
}

export default CustomerInfo
